import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Subscription } from "rxjs/Subscription";
import { TransactionsStore } from "@store/transactions";
import { DirectDebitSummary } from "@models/direct-debit-summary";

@Component({
  selector: 'direct-debit-summary-view',
  templateUrl: './direct-debit-summary-view.pug',
})
export class DirectDebitSummaryViewComponent implements OnInit, OnDestroy {

  private transactionsSubscription: Subscription

  public dds: DirectDebitSummary

  constructor(
    private store: Store<AppState>,
    private router: Router
  ) {}

  ngOnInit() {
    this.transactionsSubscription =
      this.store.select("transactionsReducer")
        .subscribe((s: TransactionsStore) => {
          this.dds = s.activeDirectDebitSummary
        })
  }

  clickedViewAll(target: string) {
    this.router.navigate(['direct-debit-summaries', this.dds.id, target])
  }

  ngOnDestroy() {
    this.transactionsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/direct-debit-summary-view.ts